var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg4Ingos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 188,
    viewBox: "0 0 188 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 94,
    r: 93.5,
    fill: "#93E0FC",
    stroke: "#DDDDDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.0781 97.063C50.0781 94.198 52.4011 91.875 55.2661 91.875C58.1311 91.875 60.4542 94.198 60.4542 97.063C60.4542 99.928 58.1311 102.251 55.2661 102.251C52.4011 102.251 50.0781 99.928 50.0781 97.063Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.016 97.063C103.016 94.198 105.339 91.875 108.204 91.875C111.069 91.875 113.392 94.198 113.392 97.063C113.392 99.928 111.069 102.251 108.204 102.251C105.339 102.251 103.016 99.928 103.016 97.063Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4141 126.768C70.5374 135.496 92.495 135.559 111.668 126.941L112.053 126.768",
    stroke: "white",
    strokeWidth: 4.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg4Ingos);
export default __webpack_public_path__ + "static/media/svg-4-ingos.97a2fa48e4f65c5fbe9d697d7899fb30.svg";
export { ForwardRef as ReactComponent };